import TabellaLezioni from "./storico/storico_lezioni/tabellaLezioni.jsx"
import TabsPacchetti from "./storico/storico_lezioni/tabs_pacchetto.jsx"
import NoleggiStorico from "./storico/storico_noleggi/noleggi.jsx"
import StorageStorico from "./storico/storage/storage.jsx"
import EscursioniStorico from "./storico/storico_escursioni/storico_esc.jsx"
import SpeseStorico from "./storico/storico_spese/storico_spese.jsx"
import RiparazioniStorico from "./storico/riparazioni/repairs.jsx"
import StoricoConti from "./storico/conti/storicoConti";
import {dizionarioTraduzioni} from "../funzioni/traduzioni";
import { useEffect, useState, useRef } from "react";
import {
    getIndiceStorico,
    setIndiceStorico,setFinePeriodo, setInizioPeriodo,getInizioPeriodo,getFinePeriodo,getLingua
} from "../auth";
import "../stili/tabs.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-free/css/all.min.css"
import {DateTime} from "luxon";
import StoricoFatture from "./storico/storico_fatture/fatture";
/* global $ */
function Storico() {
    const [selectedIndex,setSelectedIndex]=useState(0)
    const [selectedIndex2,setSelectedIndex2]=useState(0)
    let fineModIn1
    let fineModIn2
    let inizioModIn1
    let inizioModIn2
    const lingua=getLingua()
  useEffect(() => {
    const tabsIconAndText = [
      { id: 0, text: dizionarioTraduzioni(lingua,'Lezioni'), icon: "fa-solid fa-book-open" },
      { id: 1, text: dizionarioTraduzioni(lingua,'Noleggi'), icon: "fa-solid fa-wind" },
      { id: 2, text: dizionarioTraduzioni(lingua,'Storage'), icon: 'fa-solid fa-shop-lock' },
      { id: 3, text: dizionarioTraduzioni(lingua,'Riparazioni'), icon: 'fa-solid fa-screwdriver-wrench' },
      { id: 4, text: dizionarioTraduzioni(lingua,'Escursioni'), icon: 'fa-solid fa-earth-africa' },
      { id: 5, text: dizionarioTraduzioni(lingua,'Spese'), icon: 'fa-solid fa-credit-card' },
      { id: 6, text: dizionarioTraduzioni(lingua,'Conti'), icon: 'fa-solid fa-users' },
      { id: 7, text: dizionarioTraduzioni(lingua,'Fatture'), icon: 'fa-solid fa-file-invoice' },
    ];
    console.log(getFinePeriodo()!=="null" ? new Date(getFinePeriodo()) : new Date())
    const datebox=$("#dateboxriferimenti").dxDateRangeBox({
            displayFormat: "dd/MM/yyyy",
            startDateLabel: dizionarioTraduzioni(lingua,'Inizio periodo'),
            endDateLabel: dizionarioTraduzioni(lingua,'Fine periodo'),
            showClearButton: true,
            openOnFieldClick: true,
        startDateInputAttr: { readonly: true, onkeydown: "return false", inputmode: 'none' },
endDateInputAttr:   { readonly: true, onkeydown: "return false", inputmode: 'none' },
            startDate: getInizioPeriodo()!=="null" ? new Date(getInizioPeriodo()) :new Date(),
            endDate: getFinePeriodo()!=="null" ? new Date(getFinePeriodo()) : new Date(),
            onValueChanged:function(e){
                setInizioPeriodo(DateTime.fromJSDate(e.value[0]).toISO())
                setFinePeriodo(DateTime.fromJSDate(e.value[1]).toISO())
            },
            onFocusOut: function(e){
            fineModIn1= $("#dateboxriferimenti").dxDateRangeBox("instance").option("startDate")
            fineModIn2= $("#dateboxriferimenti").dxDateRangeBox("instance").option("endDate")
            if (inizioModIn1!==fineModIn1 ||inizioModIn2!==fineModIn2){
                window.location.reload()
            }
        },
        onFocusIn: function(e){
            inizioModIn1= $("#dateboxriferimenti").dxDateRangeBox("instance").option("startDate")
            inizioModIn2= $("#dateboxriferimenti").dxDateRangeBox("instance").option("endDate")
        },
        }).dxDateRangeBox("instance")
    const tabs =$('#withIconAndText').dxTabs({
      width: '100%',
      rtlEnabled: false,
      scrollByContent: true,
      dataSource: tabsIconAndText,
      orientation: "horizontal",
      stylingMode: "secondary",
      iconPosition: "top",
      onSelectionChanged: function (e) {
      setSelectedIndex( e.component.option("selectedIndex"));
      let passo =false
      e.component.option("selectedIndex")>=0?setIndiceStorico(e.component.option("selectedIndex")):passo=true
    },
      itemTemplate: function (itemData) {
          return `<div style="display: flex; flex-direction: column; align-items: center;">
                    <i class="${itemData.icon}" style="font-size: 20px;"></i>
                    <div>${itemData.text}</div>
                  </div>`;
        },
    }).dxTabs('instance');
    tabs.option("selectedIndex", getIndiceStorico()>=0?getIndiceStorico():0)
  }, []);
  return (
  <div>
      <div id="dateboxriferimenti" style={{width:"50%",minWidth:"300px",borderRadius:"10px"}} ></div>
  <div id="withIconAndText" ></div>
  {selectedIndex===0 && <div> <TabsPacchetti onChange={setSelectedIndex2} /><TabellaLezioni selectedIndex2={selectedIndex2}/></div>}
  {selectedIndex===1 && <NoleggiStorico/>}
  {selectedIndex===2 && <StorageStorico/>}
  {selectedIndex===3 && <RiparazioniStorico/>}
  {selectedIndex===4 && <EscursioniStorico/>}
  {selectedIndex===5 && <SpeseStorico/>}
  {selectedIndex===6 && <StoricoConti/>}
  {selectedIndex===7 && <StoricoFatture/>}
  <div id="loadingOverlay">
      <div class="spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
  </div>
  </div>)
}
export default Storico;